<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-dark">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">書籍詳細情報</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div v-if="Book == null">
          <base-alert type="warning">
            <span class="alert-inner--icon"><i class="fa fa-question"></i></span>
            <span class="alert-inner--text"><strong>書籍情報無し</strong> 書籍情報が見つかりませんでした。URLをお確かめいただくか、再読み込みして下さい。</span>
          </base-alert>
        </div>
        <div v-else>
          <div class="row text-center justify-content-center">
            <div class="col-lg-10">
              <h2 class="display-3">{{ Book.Name }}</h2>
              <p v-show="Book.SubTitle != null">{{ Book.SubTitle }}</p>
            </div>
          </div>
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <p class="lead">{{ Book.Lead }}</p>
                <p v-html="Book.Description"></p>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src="Book.ImageUrl" class="img-fluid shadow">
            </div>
          </div>
          <hr>
          <div class="row row-grid align-items-center">
            <div class="col-md-6">
              <div v-if="Book.DisplayCPName != null">
                <h5>{{ Book.DisplayCPName }}（{{ Book.MainCharacter }}・{{ Book.PartnerCharacter }}）{{ Book.Type }}</h5>
              </div>
              <div v-else>
                <h5>{{ Book.MainCharacter }}中心{{ Book.Type }}</h5>
              </div>
              <div v-if="Book.OtherCharacters != null">
                <h6>　　その他主要人物：
                  <span v-for="(item, index) in Book.OtherCharacters" :key="item.id">
                  {{ item }}
                  <span v-if="index != Book.OtherCharacters.length - 1">,&nbsp;</span>
                </span>
                </h6>
              </div>
              <hr>
              <h5>{{ Book.PublishDate }}（{{ Book.EventName }}）初版第一刷発行</h5>
              <h5>{{ Book.Size }} {{ Book.Pages }}P　イベント頒布価格 {{ Book.Price }} 円</h5>
            </div>
            <div class="col-md-6">
              <div v-if="Book.OtherAuthors != null">
                <div v-if="Book.IsAnthology == true">
                  <h5 v-if="Book.OtherAuthors['表紙']">表紙：{{ Book.OtherAuthors['表紙'] }}</h5>
                  <h5>参加者：</h5>
                  <div v-for="item in Book.OtherAuthors['参加者']" :key="item.id">
                    <h5>　　{{ item }}</h5>
                  </div>
                </div>
                <div v-else>
                  <div v-for="(item, key, index) in Book.OtherAuthors" :key="index">
                    <h5>{{ key }}：{{ item }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <div class="row row-grid align-items-center">
            <div class="col-md-12">
              <div class="btn-wrapper">
                <div v-if="Book.OnSaleWithPaper == true && Book.OnlineStore">
                  <a :href="Book.OnlineStore" target="_blank">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="ni ni-cart">
                      BOOTHで購入
                    </base-button>
                  </a>
                </div>
                <div v-else-if="Book.OnSaleWithPaper == true && !Book.OnlineStore">
                  <base-button class="mb-3 mb-sm-0"
                               outline type="warning"
                               icon="fa fa-clock-o" disabled>
                    BOOTH準備中
                  </base-button>
                </div>
                <div v-else-if="Book.OnSaleWithDigital == true">
                  <a :href="Book.OnlineStore" target="_blank">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="ni ni-tablet-button">
                      BOOTHで購入(電子版)
                    </base-button>
                  </a>
                </div>
                <div v-else>
                  <base-button class="mb-3 mb-sm-0"
                               type="secondary" disabled
                               icon="ni ni-fat-remove">
                    完売しました
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "bookDetail",
  components: {
    moment
  },
  data() {
    return{
      Book: {},
      Events: [],
      HeadParam: {
        title: '書籍詳細情報',
        description: '',
        image: location.origin + '/img/brand/default.png',
        card_type: 'summary_large_image'
      }
    };
  },
  head: {
    title: function () {
      return{
        inner: '雛菊書房',
        separator: ' - ',
        complement: this.HeadParam.title
      }
    },
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - ' + this.HeadParam.title },
        { property: 'og:type', content: 'article' },
        { property: 'og:description', content: this.HeadParam.description },
        { property: 'og:image', content: this.HeadParam.image },
        { property: 'twitter:card', content: this.HeadParam.card_type },
      ]
    }
  },
  created() {
    moment.locale('ja')
    this.getEvents()
    this.getBook(this.$route.params.id)
  },
  updated () {
    this.$emit('updateHead');
  },
  methods: {
    getBook(BookId) {
      this.axios.get('/strapi/api/book-informations?populate=%2A&filters[BookId][$eq]=' + BookId)
          .then(response =>{
            if(response.data.data.length != 0){
              this.Book = response.data.data[0].attributes
              if(this.Book['EventId'] !== null){
                if(this.Events.find(el => Number(el.id) == Number(this.Book['EventId'])) != null) {
                  this.Book['EventName'] = this.Events.find(el => el.id == this.Book['EventId']).attributes.Name
                  this.Book['EventInfo'] = this.Events.find(el => el.id == this.Book['EventId']).attributes
                }
              }
              switch (this.Book['Size']){
                case 'Duodecimo':
                  this.Book['Size'] = "四六判";
                  break;
                case 'Paperback':
                  this.Book['Size'] = "文庫";
                  break;
                case 'Others':
                  this.Book['Size'] = "その他";
                  break;
                default:
                  break;
              }
              switch (this.Book['Type']){
                case 'Normal':
                  this.Book['Type'] = "小説本";
                  break;
                case 'Short':
                  this.Book['Type'] = "短編小説本";
                  break;
                case 'ShortStories':
                  this.Book['Type'] = "短編集";
                  break;
                case 'Series':
                  this.Book['Type'] = "小説本(シリーズ)";
                  break;
                case 'LongStory':
                  this.Book['Type'] = "中長編小説本";
                  break;
                case 'StoryAnthology':
                  this.Book['Type'] = "小説合同誌・アンソロジー";
                  break;
                case 'StoryComicsAnthology':
                  this.Book['Type'] = "小説漫画合同誌・アンソロジー";
                  break;
                case 'AllTypeAnthology':
                  this.Book['Type'] = "合同誌・アンソロジー";
                  break;
                case 'Others':
                  this.Book['Type'] = this.Book['OtherType'];
                  break;
                default:
                  break;
              }
              this.Book['PublishDate'] = moment(this.Book['PublishDate']).format('YYYY/MM/DD')
              if (this.Book['Description'] !== null){
                this.Book['Description'] = this.Book['Description'].replace(/\r?\n/g, '<br >');
              }
              if (response.data.data[0].attributes.Image.data != null){
                this.Book['ImageUrl'] = '/strapi' + response.data.data[0].attributes.Image.data.attributes.url
                this.HeadParam.title =  response.data.data[0].attributes.Name
                this.HeadParam.description = response.data.data[0].attributes.Lead
                this.HeadParam.image = location.origin + '/strapi' + response.data.data[0].attributes.Image.data.attributes.formats.thumbnail.url
              } else {
                this.Book['ImageUrl'] = null
                this.HeadParam.title =  response.data.data[0].attributes.Name
                this.HeadParam.description = response.data.data[0].attributes.Lead
                this.HeadParam.card_type = 'summary'
              }
            } else {
              this.Book = null
              this.HeadParam.card_type = 'summary'
            }
          }).catch(error =>{
        console.log(error)
      })
    },
    getEvents() {
      this.axios.get('/strapi/api/event-informations?pagination[pageSize]=50')
          .then(response =>{
            this.Events = response.data.data
          }).catch(error =>{
        console.log(error)
      })
    },
  }
};
</script>
<style>
</style>
